import React, { useEffect, useState } from 'react';
import { Alert, Box, Card, CardContent, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { apiService } from '../services/apiService';

const StatCard: React.FC<{ label: string; value: number }> = ({ label, value }) => (
  <Card><CardContent><Typography color="text.secondary">{label}</Typography><Typography variant="h5" sx={{ fontWeight: 700 }}>{value}</Typography></CardContent></Card>
);

const AdminUserDetailPage: React.FC = () => {
  const [userId, setUserId] = useState('1');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any>(null);

  const load = async (id: string) => {
    if (!id) return;
    setLoading(true); setError(null);
    try {
      const res = await apiService.getAdminUserDetails(Number(id));
      setData(res);
    } catch (e: any) {
      setError(e?.response?.data?.message || 'Failed to fetch user details');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(userId); }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>User Insights</Typography>
      <Box sx={{ mb: 2 }}>
        <TextField
          size="small"
          label="User ID"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          onBlur={() => load(userId)}
        />
      </Box>
      {loading && <CircularProgress size={22} />}
      {error && <Alert severity="error">{error}</Alert>}
      {data && (
        <>
          <Typography sx={{ mb: 2 }}>{data.name} - {data.email}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}><StatCard label="Projects" value={data.projectsCount || 0} /></Grid>
            <Grid item xs={12} md={3}><StatCard label="Test Cycles" value={data.testCyclesCount || 0} /></Grid>
            <Grid item xs={12} md={3}><StatCard label="Environments Accessed" value={data.environmentsAccessedCount || 0} /></Grid>
            <Grid item xs={12} md={3}><StatCard label="Proxy Downloads" value={data.proxyDownloadsCount || 0} /></Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default AdminUserDetailPage;
